import React from "react";
import Auth from "opensooq-sso";
import { useSsoContext } from "contexts/authSSOContext";
import { useTheme } from "styled-components";
import dynamic from "next/dynamic";

const ChatProvider = dynamic(
  () =>
    import("opensooq-chat").then((module) => {
      return module.ChatProvider;
    }),
  { suspense: false }
);
const MainChatProvider = ({ children }) => {
  const { userInfo, isLoggedInSso } = useSsoContext();
  const { country, device, locale, host } = useTheme();
  const getToken = async () => {
    return await Auth.getInstance().getToken(true);
  };

  const authenticationData = {
    userInfo,
    source: device,
    country,
    audience: device,
  };
  const urls = {
    arbok: "",
    chat: process.env.NEXT_PUBLIC_CHAT_SOCKET_URL,
    arachnaApi: process.env.NEXT_PUBLIC_API_URL_CLIENT,
    postView: ``,
    notify: `${process.env.NEXT_PUBLIC_CDN_TYPE2}/myOS/audio/chat.mp3`,
  };

  return (
    <ChatProvider
      // @ts-ignore
      lang={locale}
      isLoggedIn={!!userInfo}
      publicUrl={`https://${host}`}
      urls={urls}
      actions={{
        onCallFailed: () => {},
        getToken,
      }}
      authenticationData={authenticationData}
    >
      {children}
    </ChatProvider>
  );
};

export default MainChatProvider;
